import React from 'react';
import styled from 'styled-components';
import { Trans } from 'react-i18next';
import Bugsnag from '@bugsnag/js';

import { Button } from 'shared/components/Button';
import { useCheckoutContext } from 'checkout/providers/CheckoutContextProvider';
import { PaymentType } from 'shared/enums/PaymentType';
import { GiftCard } from 'checkout/components/Payment/GiftCard';
import { t } from 'localization/utils/t';
import { getRedirectionPath } from 'localization/utils/getRedirectionPath';

const TP = 'checkout.components.Payment.Alipay';

export const Alipay = () => {
  const {
    addresses,
    createStripeSource,
    order: { addressId, number },
  } = useCheckoutContext();

  const handleClick = async () => {
    try {
      const shippingAddress = addresses[addressId];

      await createStripeSource(PaymentType.Alipay, shippingAddress);
    } catch (error) {
      Bugsnag.notify(error, (event) => {
        event.severity = 'error';
        event.context = 'checkout';
        event.addMetadata('checkout', { orderNumber: number });
      });
    }
  };

  return (
    <Alipay.Wrapper>
      <GiftCard />
      <p>
        {t(
          `${TP}.alipayInstructions`,
          'You will be redirected to Alipay to complete your purchase securely.',
        )}
      </p>
      <p>
        <Trans
          i18nKey={`${TP}.alipayTerms`}
          defaults="By proceeding, you confirm you have read and agree to the <br> <purchasePolicyLink>Purchases and Returns Policy</purchasePolicyLink>."
          components={{
            purchasePolicyLink: (
              <Alipay.Link href={getRedirectionPath('/returns')} target="_blank" rel="noreferrer" />
            ),
          }}
        />
      </p>
      <Button data-qa="alipay-submit-button" onClick={handleClick}>
        {t(`${TP}.continueAlipayButton`, 'Place Order with Alipay')}
      </Button>
    </Alipay.Wrapper>
  );
};

Alipay.Wrapper = styled.div`
  width: 100%;
  p {
    margin-bottom: 16px;
  }
  a {
    text-decoration: underline;
  }
  button {
    margin-top: 48px;
  }
`;

Alipay.Link = styled.a`
  text-decoration: underline;
`;

Alipay.Image = styled.img`
  width: 82px;
  margin-bottom: 12px;
`;

Alipay.Logo = styled.img`
  width: 100px;
  margin-bottom: 12px;
`;
